const Legend = ({ type }) => {
  return (
    <div className="legend-container">
      {type === "approvedPending" && (
        <div>
          <i className="fa fa-check fa-lg success"></i>
          <span className="equals">=</span>
          <span>Approved</span>
        </div>
      )}

      {type === "approvedPending" && (
        <div>
          <i className="fa fa-hourglass-o fa-lg working"></i>
          <span className="equals">=</span>
          <span>Pending</span>
        </div>
      )}

      {type === "unavailable" && (
        <div>
          <i className="fa fa-times fa-lg error"></i>
          <span className="equals">=</span>
          <span>Unavailable</span>
        </div>
      )}
    </div>
  );
};

export default Legend;
